export default __webpack_public_path__ + "static/media/seekLogo@4x.7d3980a2.png";